/** Sanity slug for the discovery homepage document (served at `/`, not `/[slug]`). */
export const HOMEPAGE_SLUG = "homepage";

/** Beast Academy Modality slug */
export const BEAST_ACADEMY_MODALITY_SLUG = "beast-academy";

/** Beast Academy Online enrollment / subscription page */
export const BEAST_ACADEMY_ENROLL_URL =
	"https://beastacademy.com/online/enroll";

/** Platform application code for auth/gateway. */
export const PLATFORM_APPLICATION_CODE = "one";

/** Maximum character length for course card descriptions before truncation. */
export const COURSE_CARD_DESCRIPTION_MAX_LENGTH = 150;
